fragment AudienceMembership on AudienceMember {
    id
    audience {
        id
        name
        isWebFX
    }
}
